import { FunctionField, FunctionFieldProps } from 'react-admin';
import Chip from '@mui/material/Chip';
import { makeStyles } from '@mui/styles';
import { resolvePath } from '@components';

export const syntageStatusOptions = [
  { id: 'valid', name: 'Valid', color: '#297721' },
  { id: 'invalid', name: 'Invalid', color: '#DD482E' },
  { id: '', name: 'N/A', color: '#a1a1a1' },
];

interface Props {
  autoWidth?: boolean;
  value?: string;
}

export const SyntageStatusField = (props: Props & Partial<FunctionFieldProps>) => {
  const cls = useStyles();
  const { autoWidth, ...restProps } = props;

  return (
    <FunctionField {...restProps} className={cls.chipWrap} render={(record: any) => {
      const status = props.value
        || resolvePath(record, props.source || 'syntageProfile.credentialStatus')
        || resolvePath(record, props.source || 'user.syntageProfile.credentialStatus');
      const statusName = syntageStatusOptions.find(o => o.id === status)?.name;
      const color: any = syntageStatusOptions.find(o => o.id === status)?.color;

      return record && color ? (
        <Chip
          label={statusName || status}
          size="small"
          style={{
            backgroundColor: color ?? undefined,
            width: autoWidth ? 'auto' : '100%',
            padding: autoWidth ? '5px 15px' : undefined,
          }}
          className={cls.chip}
        />
      ) : null;
    }} />
  );
};

const useStyles = makeStyles({
  chip: {
    color: 'white !important',
    width: 'auto !important',
    lineHeight: 16,
    display: 'inline-flex',
    '& *': {
      color: 'white !important',
      lineHeight: 'normal',
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  chipWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
